import { TABLE_IDS, parseCellId } from '@cards/engine';
import { atRoundEnd, cardRef, defineGameCard } from '../authoring/index.js';
import { locationHasSpace, ownerSide } from './helpers.js';
const SELF_COPYING_DRONE_ID = 'self_copying_drone';
export const SelfCopyingDroneCard = defineGameCard({
    id: SELF_COPYING_DRONE_ID,
    gameplay: { type: 'UNIT', cost: 2, baseStats: { attack: 1, health: 1 } },
    presentation: {
        name: 'Самокопирующийся дрон',
        description: 'В конце первого пережитого раунда создаёт копию в свободной ячейке соседней локации. Эта копия больше не копируется.',
        glyph: {
            colors: ['#48545A', '#55666F', '#10213A', '#417DA3', '#272E34'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '.1121...3111........',
                '...3..33..3.........',
                '...3.2222.3.........',
                '..333244235355..555.',
                '....124423..3.22.3..',
                '....323323..111121..',
                '.....3113....1442...',
                '....3.33.3...3223...',
                '....3....3...3..3...',
                '...3......3.3....3..',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef(SELF_COPYING_DRONE_ID)],
    abilities: [
        atRoundEnd((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined || self.vars.copyResolved === true || self.vars.generation === 1)
                return;
            ctx.ops.setVar('copyResolved', true);
            const current = parseCellId(self.cellId).tableId;
            const side = ownerSide(ctx, self.controllerId);
            const destinations = TABLE_IDS.filter((tableId) => Math.abs(tableId - current) === 1 && locationHasSpace(ctx, tableId, side));
            for (const destination of destinations) {
                const copyId = ctx.ops.createTokenInLocation(SELF_COPYING_DRONE_ID, self.controllerId, destination);
                if (copyId === null)
                    continue;
                ctx.ops.setInstanceVar(copyId, 'generation', 1);
                break;
            }
        }),
    ],
    ui: {
        publicVars: {
            generation: { key: 'generation', kind: 'number' },
            copyResolved: { key: 'copyResolved', kind: 'boolean' },
        },
        statusProviders: [(context) => {
                const isCopy = context.card.facts.generation === 1;
                const resolved = context.card.facts.copyResolved === true;
                return [{
                        id: 'copy-state',
                        symbol: resolved || isCopy ? '✓' : '⧉',
                        label: 'Копирование',
                        description: isCopy
                            ? 'Это созданная копия: она больше не копируется.'
                            : resolved
                                ? 'Попытка создать копию уже выполнена.'
                                : 'В конце пережитого раунда попытается создать копию.',
                        tone: 'neutral',
                    }];
            }],
    },
});
//# sourceMappingURL=self-copying-drone.js.map